module.exports = __webpack_public_path__ + "static/img/ncut002.506c5e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ncut002.jpg
// module id = KtgJ
// module chunks = 1